<template>
  <!-- collapsed view -->
  <div v-if="!expanded" id="pwt-info-panel-expand-btn" style="z-index: 1100">
    <v-row class="pt-3">
      <v-btn icon @click="expand" class="bg-background mx-2">
        <v-icon color="primary" icon="mdi-menu"></v-icon>
      </v-btn>
    </v-row>
  </div>
  <!-- expanded view -->
  <div v-else>
    <!-- floating controls -->
    <div id="pwt-info-panel-minimize-btn" :class="classes">
    </div>
    <!-- main card -->
    <InfoPanel @minimize="minimize" :animation="animation" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useDisplay } from 'vuetify'
import InfoPanel from './InfoPanel.vue'

const { mobile } = useDisplay()

const expanded = ref(true)
const animation = ref<'slide-left' | 'slide-right' | null>(null)

const classes = computed(() => {
  if (animation.value == 'slide-left') {
    return mobile.value ? 'ma-sm-2' : 'ma-sm-2 pwt-info-panel-btn-right-to-left-animation'
  }
  if (animation.value == 'slide-right') {
    return mobile.value ? 'ma-sm-2' : 'ma-sm-2 pwt-info-panel-btn-left-to-right-animation'
  }

  return 'ma-sm-2'
})

function expand() {
  animation.value = 'slide-right'
  expanded.value = true
  clearAnimation()
}

function minimize() {
  animation.value = 'slide-left'
  setTimeout(() => {
    expanded.value = false
  }, 500)
  clearAnimation()
}

function clearAnimation() {
  setTimeout(() => {
    animation.value = null
  }, 701)
}

</script>

<style scoped>
#pwt-info-panel-expand-btn {
  z-index: 1102;
  position: absolute;
  top: 8px;
  left: 8px;
}

#pwt-info-panel-minimize-btn {
  z-index: 1102;
  position: absolute;
  top: 0;
  left: clamp(410px, calc(40% + 10px), 610px);
}

#pwt-info-panel-floating-controls-overlay {
  z-index: 1102;
  position: relative;
  min-width: 400px;
  max-width: 600px;
  width: 40%;
  height: calc(100% - 30px) !important;
  background-color: transparent;
}

.pwt-info-panel-btn-left-to-right-animation {
  left: -56%;
  -webkit-animation: btn-left-to-right 700ms linear forwards;
  animation: btn-left-to-right 700ms linear forwards;
}

.pwt-info-panel-btn-right-to-left-animation {
  left: 0;
  -webkit-animation: btn-right-to-left 1s linear forwards;
  animation: btn-right-to-left 1s linear forwards;
}

@-webkit-keyframes btn-left-to-right {
  from {
    left: 0;
  }
  to {
    left: clamp(410px, calc(40% + 10px), 610px);
  }
}
@-webkit-keyframes btn-right-to-left {
  from {
    left: clamp(410px, calc(40% + 10px), 610px);
  }
  to {
    left: -56%;
  }
}

@keyframes btn-left-to-right {
  from {
    left: 0;
  }
  to {
    left: clamp(410px, calc(40% + 10px), 610px);
  }
}
@keyframes btn-right-to-left {
  from {
    left: clamp(410px, calc(40% + 10px), 610px);
  }
  to {
    left: -56%;
  }
}
</style>
